import React from "react";
import{Countries as countries} from "../../../../services/countries";
import Edit from "../../../../assets/images/editinput.svg";
import PropTypes from 'prop-types';
import {Select} from "@appkit4/react-components/select"

function CoporateAddress(props) {
  let { values, touched, errors, handleChange, handleBlur,role, selectFieldsDisabled } = props;

  let disabledFields;
  if (role === "analyst" || role === "manager") {
    disabledFields = true
  }
  else {
    disabledFields = false //Can be changed according to future requirement.
  }

  let disabledFieldsEdit;
  if (values.thirdPartyID !== 0) {
    disabledFieldsEdit = true;
  }
  else {
    disabledFieldsEdit = false;
  }

  return (
    <div>
      <div className="row m-0">
        <div className="col-sm-6">
          <div className={disabledFields || selectFieldsDisabled || disabledFieldsEdit ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label htmlFor="AddressCorporate" className="cv-input-label">
              Address<span className="asterisk-required">*</span>
            </label>
            <input
              className={disabledFields || selectFieldsDisabled || disabledFieldsEdit ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
              onBlur={handleBlur}
              type="text"
              id="AddressCorporate" 
              value={values.address}
              onChange={handleChange("address")}
              name="address"
              placeholder={"Please enter Address"}
              disabled={disabledFields || selectFieldsDisabled || disabledFieldsEdit}
            />
            <img alt="edit" src={Edit} className="edit-input" />
          </div>
          {errors.address && touched.address && (
            <div className="form-label error">{errors.address}</div>
          )}
        </div>
        <div className="col-sm-6">
          <div className={disabledFields || selectFieldsDisabled || disabledFieldsEdit ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label className="cv-input-label">
              Country<span className="asterisk-required">*</span>
            </label>
            <Select
              showSearchOnToggle={true}
              dropdownRenderMode="portal"
              searchable={true}
              className="cv-input-field "
              value={values.country}
              data={countries}
              valueKey="code"
              labelKey="name"
              onSelect={(e) =>
                handleChange("country")({ target: { value: e } })
              }
              name="country"
              placeholder={"Select Country"}
              disabled={disabledFields || selectFieldsDisabled || disabledFieldsEdit}
            >
            </Select>
          </div>
          {errors.country && touched.country && (
            <div className="form-label error">{errors.country}</div>
          )}
        </div>
      </div>
      <div className="row m-0">
        <div className="col-sm-6">
          <div className={disabledFields || selectFieldsDisabled || disabledFieldsEdit ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label htmlFor="CityCorporate" className="cv-input-label">City <span className="asterisk-required">*</span></label>
            <input
              className={disabledFields || selectFieldsDisabled || disabledFieldsEdit ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
              onBlur={handleBlur}
              id="CityCorporate"
              type="text"
              value={values.city}
              onChange={handleChange("city")}
              name="city"
              placeholder={"Please enter City Name"}
              disabled={disabledFields || selectFieldsDisabled || disabledFieldsEdit}
            />
            <img alt="edit" src={Edit} className="edit-input" />
          </div>
          {errors.city && touched.city && (
            <div className="form-label error">{errors.city}</div>
          )}
        </div>
        <div className="col-sm-6">
          <div className={disabledFields || selectFieldsDisabled || disabledFieldsEdit ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label htmlFor="StateCorporate" className="cv-input-label">
              State<span className="asterisk-required">*</span>
            </label>
            <input
              className={disabledFields || selectFieldsDisabled || disabledFieldsEdit ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
              onBlur={handleBlur}
              id="StateCorporate" 
              type="text"
              value={values.state}
              onChange={handleChange("state")}
              name="state"
              placeholder={"Please enter State Name"}
              disabled={disabledFields || selectFieldsDisabled || disabledFieldsEdit}
            />
            <img alt="edit" src={Edit} className="edit-input" />
          </div>
          {errors.state && touched.state && (
            <div className="form-label error">{errors.state}</div>
          )}
        </div>
      </div>
      <div className="row m-0">
        <div className="col-sm-6">
          <div className={disabledFields || selectFieldsDisabled || disabledFieldsEdit ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label htmlFor="ZipCorporate" className="cv-input-label">
              Zip<span className="asterisk-required">*</span>
            </label>
            <input
              className={disabledFields || selectFieldsDisabled || disabledFieldsEdit ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
              onBlur={handleBlur}
              id="ZipCorporate" 
              type="tel"
              value={values.zip}
              onChange={handleChange("zip")}
              name="zip"
              placeholder={"Please enter Zip"}
              disabled={disabledFields || selectFieldsDisabled || disabledFieldsEdit }
            />
            <img alt="edit" src={Edit} className="edit-input" />
          </div>
          {errors.zip && touched.zip && (
            <div className="form-label error">{errors.zip}</div>
          )}
        </div>
        <div className="col-sm-6">
          <div className={disabledFields || selectFieldsDisabled || disabledFieldsEdit ? "cv-input-field-container-disabled" : "cv-input-field-container"}>
            <label htmlFor="PhoneNumberCorporate" className="cv-input-label">
              Phone Number<span className="asterisk-required">*</span>
            </label>
            <input
              className={disabledFields || selectFieldsDisabled || disabledFieldsEdit ? "cv-input-field-disabled leftPadding" :"cv-input-field leftPadding"}
              onBlur={handleBlur}
              id="PhoneNumberCorporate" 
              type="tel"
              value={values.phonenumber}
              onChange={handleChange("phonenumber")}
              name="phonenumber"
              placeholder={"Please enter Phone Number"}
              disabled={disabledFields || selectFieldsDisabled || disabledFieldsEdit}
            />
            <img alt="edit" src={Edit} className="edit-input" />
          </div>
          {errors.phonenumber && touched.phonenumber && (
            <div className="form-label error">{errors.phonenumber}</div>
          )}
        </div>
      </div>
    </div>
  );
}

CoporateAddress.propTypes = {
  values: PropTypes.object,
  touched:PropTypes.object,
  errors:PropTypes.object,
  handleChange:PropTypes.func,
  handleBlur:PropTypes.func,
  role:PropTypes.string,
  selectFieldsDisabled: PropTypes.any
  }
export default CoporateAddress;
